var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSystemUiconsBoxOpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_246)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.33337 5L7.00004 2.33333L10.9947 4.616C11.1989 4.73263 11.3686 4.90117 11.4866 5.10454C11.6046 5.30791 11.6667 5.53887 11.6667 5.774V8.89267C11.6667 9.1278 11.6046 9.35876 11.4866 9.56213C11.3686 9.7655 11.1989 9.93404 10.9947 10.0507L7.66137 11.9553C7.45995 12.0704 7.232 12.1309 7.00004 12.1309C6.76808 12.1309 6.54013 12.0704 6.33871 11.9553L3.00537 10.0507C2.8012 9.93404 2.63151 9.7655 2.51349 9.56213C2.39547 9.35876 2.33333 9.1278 2.33337 8.89267V7.02467",
    stroke: "#ED2E7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36804 7.32667C6.56229 7.43123 6.77944 7.48597 7.00004 7.48597C7.22064 7.48597 7.4378 7.43123 7.63204 7.32667L11.3334 5.33333M7.00004 7.66667V12",
    stroke: "#ED2E7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.33337 5L7.00004 7.66667L5.00004 8.33333L0.333374 5.66667L2.33337 5ZM7.00004 2.33333L11.6667 5L13 3.66667L8.33337 1L7.00004 2.33333Z",
    stroke: "#ED2E7E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_246"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSystemUiconsBoxOpen);
export default __webpack_public_path__ + "static/media/system-uicons_box-open.76a20c4c64f87f629e95c172ead84ff0.svg";
export { ForwardRef as ReactComponent };